import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { I18nService } from '@platform/i18n';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const excludedPaths = [
    '/auth/login',
    '/auth/captcha/get',
    '/auth/register',
    '/auth/verify-otp',
  ];

  const url = new URL(req.url, window.location.origin);
  const isExcluded = excludedPaths.some(path =>
    url.pathname.startsWith(path)
  );

  let i18n = inject(I18nService);
  const headers: any = {
    'Accept-Language': i18n.getCurrentLocale()
  }

  if (isExcluded) {
    return next(req.clone({
      setHeaders: headers
    }));
  }

  const token = localStorage.getItem('token');

  if (!token) {
    return next(req.clone({
      setHeaders: headers
    }));
  }

  else {
    headers['Authorization'] = `Bearer ${token}`;
    return next(
      req.clone({
        setHeaders: headers
      })
    )
  }
};
